export enum VehicleClassEnum {
    Unknown,
    C0,
    C1,
    C2,
    C3,
    C4,
    C5,
    C6,
}